import React, { useState } from 'react';
import { Plus } from 'lucide-react';
import { TicketFormModal } from './tickets/TicketFormModal';
export function QuickTicket() {
  const [isOpen, setIsOpen] = useState(false);
  return <>
      <button onClick={() => setIsOpen(true)} className="fixed bottom-8 right-8 z-40 bg-seform-orange text-white p-4 rounded-full shadow-lg hover:bg-orange-600 transition-colors duration-150 group" title="Nuovo ticket" aria-label="Nuovo ticket" data-id="element-978" data-mp="3d8cxhm360lh4">
        <Plus className="h-6 w-6 group-hover:rotate-90 transition-transform duration-200" data-id="element-979" data-mp="dsyct0jfc7ht" />
      </button>
      <TicketFormModal isOpen={isOpen} onClose={() => setIsOpen(false)} data-id="element-980" data-mp="3vyul5c954qvm" />
    </>;
}